export const STATUS_TOAST_DURATION_MS = 9000;
export const STATUS_TOAST_MAX_DURATION_MS = 20000;
export const STATUS_TOAST_SHORT_MESSAGE_CHARS = 80;
export const STATUS_TOAST_MS_PER_EXTRA_CHAR = 60;

export const STATUS_TOAST_DEFAULT_TEST_ID = 'status-toast';

export enum StatusToastVariant {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Loading = 'loading',
  Undo = 'undo',
}

export enum StatusToastActionVariant {
  Button = 'button',
  Clickable = 'clickable',
}

export enum ToastPosition {
  Top = 'top',
  TopRight = 'top-right',
  TopLeft = 'top-left',
  Bottom = 'bottom',
  BottomRight = 'bottom-right',
  BottomLeft = 'bottom-left',
}
